module.exports = {
  PROFILE_URL: process.env.PROFILE_URL,
  APP_INSIGHT_CON_STRING: process.env.APP_INSIGHT_CON_STRING,
  BFF_HOST: process.env.BFF_HOST
}
